import { ActivityGame, GameProvider } from "../game"
import { buildRelativeUrl } from "../../../common/utils/web-utils"
import { NavigateFunction } from "react-router-dom"
import { ArcademicsGameLauncher } from "./game-launcher-arcademics"
import { MygoorooGameLauncher } from "./game-launcher-mygooroo"


export class GameLauncher {

  constructor(private game: ActivityGame) {
  }

  static launch(game: ActivityGame, navigate: NavigateFunction) {

    if(game.providerId === GameProvider.ARCADEMICS) {
      ArcademicsGameLauncher.launch(game, navigate);
      return;
    }

    else if(game.providerId === GameProvider.MYGOOROO) {
      MygoorooGameLauncher.launch(game, navigate);
    }

  }

}